<template>
  <div role="main">
    <div class="ibox data-filter">
      <div class="ibox-content px-3 pt-3 pb-2">

        <b-form @submit="onSubmitFilter">
          <b-row>
            <b-col cols="12" md="6" lg="4">
              <label for="filter-select-date" class="sr-only">Date</label>
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <font-awesome-icon icon="calendar-alt" />
                  </div>
                </div>
                <select
                  name="date"
                  id="filter-select-date"
                  class="form-control"
                  v-model="filter.date"
                  @change="requestData">

                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="weekly">Weekly</option>
                </select>
              </div>
            </b-col>
            <b-col cols="12" md="6" lg="4">
              <label for="filter-select-date" class="sr-only">ID</label>
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <font-awesome-icon icon="id-card" />
                  </div>
                </div>
                <input
                  name="click_id"
                  placeholder="Search ID"
                  type="text"
                  id="filter-input-click-id"
                  class="form-control"
                  minlength="3"
                  v-model="filter.user"/>
                <div class="input-group-append">
                  <b-button type="submit" variant="dark">
                    <font-awesome-icon icon="check" /> Apply
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-form>

      </div>
    </div>

    <div class="ibox" v-bind:class="{ full: fullscreen }">
      <div id="d-table-scroll" class="ibox-title">
        <span>
          Conversions
        </span>
        <div class="ibox-tools">
          <div role="group" arial-label="Action" class="btn-group btn-group-sm">
            <b-btn variant="secondary" v-on:click="requestData">
              <font-awesome-icon icon="sync-alt" :spin="processing" />
            </b-btn>
            <b-btn variant="secondary" v-on:click="toogleScreen">
              <font-awesome-icon v-bind:icon="fullscreen ? 'window-minimize' : 'window-maximize'"/>
            </b-btn>
          </div>
        </div>
      </div>

      <div class="ibox-content">

        <b-form v-if="fullscreen" @submit="onSubmitFilter">
          <b-row>
            <b-col cols="12" md="6" lg="4">
              <label for="filter-select-date" class="sr-only">Date</label>
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <font-awesome-icon icon="calendar-alt" />
                  </div>
                </div>
                <select
                  name="date"
                  id="filter-select-date"
                  class="form-control"
                  v-model="filter.date"
                  @change="requestData">

                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="weekly">Weekly</option>
                </select>
              </div>
            </b-col>
            <b-col cols="12" md="6" lg="4">
              <label for="filter-select-date" class="sr-only">ID</label>
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <font-awesome-icon icon="id-card" />
                  </div>
                </div>
                <input
                  name="click_id"
                  placeholder="Search ID"
                  type="text"
                  id="filter-input-click-id"
                  class="form-control"
                  v-model="filter.user"/>
                <div class="input-group-append">
                  <b-button type="submit" variant="dark">
                    <font-awesome-icon icon="check" /> Apply
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-form>

        <div class="table-beauty">
          <div class="beauty-scoped">
            <div class="table-responsive">

              <table class="table table-hover table-bordered has-paging">
                <thead>
                  <tr>
                    <th scope="col" class="sorting">
                      Date
                      <a
                        href="#"
                        :class="getOrderByClass( 'created_at' )"
                        v-on:click="toggleOrderBy( $event, 'created_at'  )"/>
                    </th>
                    <th scope="col" class="sorting">
                      ID
                      <a
                        href="#"
                        :class="getOrderByClass( 'click_id' )"
                        v-on:click="toggleOrderBy( $event, 'click_id'  )"/>
                    </th>
                    <th scope="col" class="sorting">
                      <span class="d-none d-md-inline text-nowrap"> Traffic Type</span>
                      <span class="d-inline d-md-none"> TT</span>
                      <a
                        href="#"
                        :class="getOrderByClass( 'traffic_type' )"
                        v-on:click="toggleOrderBy( $event, 'traffic_type'  )"/>
                    </th>
                    <th scope="col" class="sorting">
                      Country
                      <a
                        href="#"
                        :class="getOrderByClass( 'country' )"
                        v-on:click="toggleOrderBy( $event, 'country'  )"/>
                    </th>
                    <th scope="col" class="sorting">
                      Payout
                      <a
                        href="#"
                        :class="getOrderByClass( 'amt' )"
                        v-on:click="toggleOrderBy( $event, 'amt'  )"/>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="odd" v-if="processing && !table.initial">
                    <td valign="center" colspan="5" class="no-hover">
                      <div class="loading-spinner"><div class="spin">Loading...</div></div>
                    </td>
                  </tr>
                  <tr class="odd" v-if="!table.rows.length && table.initial">
                    <td valign="top" colspan="5" class="no-hover text-center">No data available in table</td>
                  </tr>
                  <tr role="row" v-for="(item, index) in table.rows" v-bind:key="index" :class="index % 2 ? 'even' : 'odd'">
                    <td class="text-nowrap" nowrap>{{ item.created_at }}</td>
                    <td class="clickid-row">{{ item.click_id }}</td>
                    <td>{{ item.traffic_type }}</td>
                    <td nowrap>
                      <div v-if="item.country instanceof Object" class="text-nowrap">
                        <i class="flag-icon" v-bind:class="'flag-icon-' + item.country.iso"></i>
                        <span class="d-none d-md-inline"> {{ item.country.name }}</span>
                        <span class="d-inline d-md-none"> {{ item.country.iso | uppercase }}</span>
                      </div>
                      <div v-else nowrap>
                        {{ item.country }}
                      </div>
                    </td>
                    <td>{{ item.amt }}</td>
                  </tr>
                </tbody>
              </table>

              <div class="table-beaury-loading" v-if="processing && table.initial"/>
            </div>
          </div>
          <div class="row table-beauty-bottom" v-show="table.initial">
            <div class="col-sm-12 col-md-5">
              <div class="table-beauty-info" aria-live="polite"> Showing {{ table.rows.length ? ( table.pagination.offset + 1 ) : 0 }} to {{ table.rows.length + table.pagination.offset }} of {{ table.countAll }} entries</div>
            </div>
            <div class="col-sm-12 col-md-7">
              <div class="table-beauty-paginate" aria-label="Page navigation conversions">
                <ul class="pagination">
                  <li class="page-item" :class="{ 'disabled': !table.prev }">
                    <a href="#" class="page-link" v-on:click="goTablePage( $event, ( table.pagination.current - 1 ) )">Previous</a>
                  </li>
                  <li class="page-item" v-for="n in table.pagination.total" v-bind:key="n" :class="table.pagination._current == n ? 'active' : ''">
                    <a href="#" class="page-link" v-on:click="goTablePage( $event, n )">{{ n }}</a>
                  </li>
                  <li class="page-item" :class="{ 'disabled': !table.next }">
                    <a href="#" class="page-link" aria-label="Next" v-on:click="goTablePage( $event, ( table.pagination.current + 1 ) )"> Next</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  const Cookies = require( 'js-cookie' );
  const moment = require('moment');
  const axios = require('axios');
  const CancelToken = axios.CancelToken;

  export default {
    data () {
      return {
        title: '',
        processing: false,
        fullscreen: false,
        filter: {
          date: 'today',
          user: ''
        },
        table: {
          initial: false,
          countAll: 0,
          pagination: {
            offset: 0,
            current: 1,
            _current: 1,
            total: 0,
            prev: false,
            next: false
          },
          rows: [],
          requestCancel: null,
          orderBy: {
            key: 'created_at',
            type: 'desc'
          },
          tempOrderBy: {
            key: 'created_at',
            type: 'desc'
          }
        },
      };
    },
    created() {
      this.requestData();
    },
    filters: {
      uppercase: value => {
        if ( !value ) {
          return '';
        }

        return value.toUpperCase();
      }
    },
    methods: {
      getOrderByClass( key ) {
        const typeToClass = ( src ) => {
          if ( src === 'desc' ) {
            return 'sorting_desc';
          }
          if ( src === 'asc' ) {
            return 'sorting_asc';
          }
        };

        if ( this.table.orderBy.key === key ) {
          return typeToClass( this.table.orderBy.type );
        }

        return 'sorting';
      },
      toggleOrderBy( event, key ) {
        let type = 'asc';

        if ( this.table.orderBy.key === key ) {
          if ( this.table.orderBy.type === 'desc' ) {
            type = 'asc';
          }
          else {
            type = 'desc';
          }
        }

        if ( event.preventDefault ) {
          event.preventDefault();
          this.table.tempOrderBy = { key: key, type: type };
        }
        else {
          this.table.tempOrderBy = { key: event, type: type };
        }

        this.requestData();
      },
      requestData() {
        const url = `${process.env.VUE_APP_API_URL}/api/conversions/${this.filter.date}/${this.table.pagination.current}`;
        const token = Cookies.get('__token');
        const dataParams = { };

        dataParams['order-by'] = this.table.tempOrderBy;

        if ( this.filter.user && this.filter.user.trim().length ) {
          dataParams.user = this.filter.user.trim();
        }

        if ( this.requestCancel ) {
          this.requestCancel( 'Request cancel' );
        }

        const instance = axios.create( );

        instance.interceptors.request.use( config => {
          config.headers['Authorization'] = `Bearer ${token}`;
          this.processing = true;
          return config;
        }, error => {
          return Promise.reject( error );
        });

        return instance.get( url, {
          cancelToken: new CancelToken( cancel => {
            this.requestCancel = cancel;
          }),
          params: dataParams
        } ).then( response => {
          const data = response.data;

          data.rows.map(item => {
            if ( item.created_at ) {
              item.created_at = moment( item.created_at )
                .utcOffset( 'UTC+07:00' )
                .format( 'DD/MM/YYYY, hh:mm:ss A' );
            }

            if ( !item.traffic_type ) {
              item.traffic_type = '';
            }

            if ( item.amt ) {
              item.amt = '$' + item.amt.toFixed(4);
            }
            else {
              item.amt = '$0.0000';
            }

            return item;
          });

          this.table.rows = data.rows;
          this.table.countAll = data.total;
          this.table.pagination.offset = data.pagination.offset;
          this.table.pagination.current = data.pagination.current;
          this.table.pagination._current = data.pagination.current;
          this.table.pagination.total = data.pagination.total;

          this.table.orderBy = this.table.tempOrderBy;

          // <-- start set pagination

          if ( 1 == data.pagination.current || 1 >= data.pagination.current ) {
            this.table.prev = false;
          }
          else {
            this.table.prev = true;
          }

          if ( data.pagination.total == data.pagination.current || data.rows.length <= 1 ) {
            this.table.next = false;
          }
          else {
            this.table.next = true;
          }

          // <--end set pagination

          if ( false === this.table.initial ) {
            this.table.initial = true;
          }

          this.processing = false;

          return response;
        } ).catch( error => {
          if ( false === axios.isCancel( error ) ) {
            if ( false === this.table.initial ) {
              this.table.initial = true;
            }

            this.processing = false;
          }

          if ( !error.response ) {
            // eslint-disable-next-line
            console.log( error );
            return;
          }

          const response = error.response;

          if ( response.status == 401 || response.status == 403 ) {
            this.$store.dispatch( 'authentication/logout' );
            this.$router.push('/login');
          }
        } );
      },
      toogleScreen() {
        if (this.fullscreen) {
          this.fullscreen = false;
          window.document.body.style.overflow = 'initial';
        }
        else {
          this.fullscreen = true;
          window.document.body.style.overflow = 'hidden';
        }
      },
      goTablePage( event, page ) {
        if ( event ) {
          event.preventDefault();

          const me = event.currentTarget;
          const item = me.closest('.page-item');

          if (item.classList.length && -1 !== item.className.split(' ').indexOf('active')) {
            return;
          }
        }

        this.table.pagination.current = page;

        const scrollTo = (to, duration) => {
            // eslint-disable-next-line
            const bodyElement = window.document.scrollingElement || window.document.documentElement,
              iboxElement = window.document.querySelector('.ibox.full'),
              element = this.fullscreen ? iboxElement : bodyElement,
              start = element.scrollTop,
              change = to - start,
              startDate = +new Date(),

            // t = current time
            // b = start value
            // c = change in value
            // d = duration

            easeInOutQuad = function(t, b, c, d) {
                t /= d/2;
                if (t < 1) return c/2*t*t + b;
                t--;
                return -c/2 * (t*(t-2) - 1) + b;
            },

            animateScroll = function() {
                const currentDate = +new Date();
                const currentTime = currentDate - startDate;
                element.scrollTop = parseInt(
                  easeInOutQuad(currentTime, start, change, duration),
                  10
                );
                if(currentTime < duration) {
                    requestAnimationFrame(animateScroll);
                }
                else {
                    element.scrollTop = to;
                }
            };

            animateScroll();
        };

        const elDTable = window.document.getElementById('d-table-scroll');
        const absoluteOffset = elem => {
          return elem.offsetParent && elem.offsetTop + absoluteOffset(elem.offsetParent);
        };

        this.requestData()
          .then( () => scrollTo( absoluteOffset(elDTable), 500 ) )
          .catch( error => {
            if ( false === axios.isCancel( error ) ) {
              scrollTo( absoluteOffset(elDTable), 500 );
            }
          } );
      },
      onSubmitFilter( event ) {
        event.preventDefault();

        this.requestData();
      }
    },
    beforeRouteLeave( to, from, next ) {
      this.processing = true;
      next();
    }
  };
</script>